import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

// Use a custom storage key to isolate auth state from other projects
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'jb-auth-token',
    storage: localStorage,
  },
});

// Helper to clear any stale auth state when refresh token errors occur
export async function clearStaleAuth(): Promise<void> {
  try {
    localStorage.removeItem('jb-auth-token');
    localStorage.removeItem('sb-rufcndpzqmdnhoocqtpo-auth-token');
    localStorage.removeItem('sb-refresh-token');
    localStorage.removeItem('sb-access-token');
    // Clear any supabase-related keys
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('sb-') || key.includes('supabase') || key.includes('auth'))) {
        localStorage.removeItem(key);
      }
    }
    await supabase.auth.signOut({ scope: 'local' });
  } catch {
    // Ignore cleanup errors
  }
}